import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const QR_IMAGE =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_e9adf799-781d-4ffe-a0b9-a2d9c34c4036/artifacts/4sf3hrte_IMG_6801.jpeg";

// Decoded from the organisation's own UPI QR image above (verified, do not change without a new QR).
export const UPI_ID = "Pos.11423419@indus";

export const api = axios.create({ baseURL: API });

export const getCampaigns = () => api.get("/campaigns").then((r) => r.data);
export const createVisitor = (data) => api.post("/visitors", data).then((r) => r.data);
export const confirmUpi = (data) => api.post("/upi/confirm", data).then((r) => r.data);
export const createOrder = (data) => api.post("/razorpay/create-order", data).then((r) => r.data);
export const verifyPayment = (data) => api.post("/razorpay/verify", data).then((r) => r.data);
export const createSubscription = (data) =>
  api.post("/razorpay/create-subscription", data).then((r) => r.data);

export const fullUrl = (u) => (u && u.startsWith("http") ? u : `${BACKEND_URL}${u}`);
export const getDonorWall = () => api.get("/donor-wall").then((r) => r.data);
export const uploadDonorPhoto = (formData) =>
  api.post("/donor-wall/upload", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const getContent = (key) => api.get(`/content/${key}`).then((r) => r.data.content).catch(() => null);
export const getPublicSettings = () => api.get("/settings").then((r) => r.data).catch(() => null);
export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
